const PillarTableFilterSelectPageButton = ({
  filterKey,
  direction,
  onClick,
}: {
  filterKey: string;
  direction: "prev" | "next";
  onClick: () => void;
}) => (
  <button
    type="button"
    id={`filter-page-${filterKey}-${direction}`}
    data-testid={`filter-page-${filterKey}-${direction}`}
    className="p-1 text-neutral-mid-800 w-full cursor-pointer flex items-center justify-center font-semibold hover:bg-neutral-light-500 phone:min-h-sm phone:min-w-sm"
    onClick={onClick}
  >
    {direction === "next" ? "Next page" : "Previous page"}
  </button>
);

export default PillarTableFilterSelectPageButton;
